import React from 'react';
import { TQuiz } from '../../../../entities/Moodle/model/MoodleTypes';
import { Collapse, Divider } from 'antd';
import UserQuizAttempt from './UserQuizAttempt';

const QuizItem = ({ quiz }: { quiz: TQuiz }) => {
    return (
        <div style={{}}>

            <Divider orientation="left" />
            <Collapse
                destroyInactivePanel={true}
                items={[{ key: '1', label: quiz.name, children: <UserQuizAttempt quiz={quiz} /> }]}
            />
        </div>
    );
};

export default QuizItem;